@if (loaded) {
  <forge-card class="pad-card">
    <forge-toolbar attr.slot="header">
      <h2 slot="start" class="forge-typography--heading4">Email Test</h2>
    </forge-toolbar>
    <div>
      <metadata-panel [metadata]="metadata" [model]="model" [viewOnly]="true"></metadata-panel>
    </div>
    <div slot="footer">
      <div fxLayout="row" fxLayoutAlign="flex-end flex-end">
        <forge-button variant="outlined" (click)="test()" [disabled]="running">
          Test
        </forge-button>
      </div>
    </div>
  </forge-card>
}